import { inject } from 'vue';
import { type LiveProjectile, PROJECTILE_CONTROLLER_KEY } from '@/components/projectile/use-projectile-provider.ts';

interface ProjectileController {
    spawn: (projectile: LiveProjectile) => void;
    removeById: (id: string) => void;
}

export function useProjectile() {
    const context = inject<ProjectileController>(PROJECTILE_CONTROLLER_KEY);
    if (!context) {
        throw new Error('useProjectile must be used within a ProjectileProvider');
    }
    return context;
}
